// @ts-nocheck

const emptyFunction = () => {};

export default emptyFunction;
